// removed by extract-text-webpack-plugin
module.exports = {"root":"root__27nIa","logo":"logo__3txfA"};


//////////////////
// WEBPACK FOOTER
// ./components/Footer/style.css
// module id = n4o+
// module chunks = 0